import { useEffect, useState, useCallback } from "react";
import { getAllBorrowerTypes, deleteBorrowerType, createBorrowerType, updateBorrowerType, unDeleteBorrowerType } from "../TableService";
import useUserID from "app/hooks/useUserID";
import useRoles from "app/hooks/useRoles";
import { STATUSLUTYPE } from '../../consts';

export default function useBorrowerType() {
  const [page, setPage] = useState(0);
  const [borrowerType, setBorrowerType] = useState(null);
  const [borrowerTypeList, setBorrowerTypeList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
  const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
  // const userID = useUserID();
  const getrolebyusername = useRoles();
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  // const isActionEnabled = getrolebyusername.includes('SA') || getrolebyusername.includes('Admin');

  const handleChangePage = (_, newPage) => setPage(newPage);

  const updatePageData = useCallback(() => {
    getAllBorrowerTypes().then(response => {
      setBorrowerTypeList(response.data.borrowerTypes || []);
    }).catch(error => {
      console.error('Failed to fetch borrower type data', error);
    });
  }, []);

  const handleDialogClose = () => {
    setShouldOpenEditorDialog(false);
    setShouldOpenConfirmationDialog(false);
    updatePageData();
  };

  const handleDeleteUnDeleteBorrowerType = (borrowerType) => {

    if (borrowerType.statusLUId === STATUSLUTYPE.DEFAULT) {
      alert("You can't delete this pre-set code.");
      return;
    }

    setBorrowerType(borrowerType);
    setShouldOpenConfirmationDialog(true);
  };

  const handleSaveBorrowerType = async (borrowerTypeDetails, isNew, setFieldError) => {

    let apiPayload;
    if (isNew) {
      apiPayload = {
        Code: borrowerTypeDetails.Code,
        Type: borrowerTypeDetails.Type,
        Description: borrowerTypeDetails.Description,
      };

      const response = await createBorrowerType(apiPayload);

      if (response.data.success) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000);
        handleDialogClose();
        setTimeout(updatePageData, 500);
      } else {
        setFieldError('Code', response.data.errorMessage);
        // alert('Failed to save borrower type.');
        return response.data.errorMessage;
      }
    } else {
      apiPayload = {
        Id: borrowerTypeDetails.Id,
        Code: borrowerTypeDetails.Code,
        Type: borrowerTypeDetails.Type,
        Description: borrowerTypeDetails.Description,
        StatusLUId: borrowerTypeDetails.StatusLUId,
      };
      const response = await updateBorrowerType(apiPayload);
      if (response.data.success) {
        handleDialogClose();
        setTimeout(updatePageData, 500);
      } else {
        return response.data.errorMessage || 'Failed to save borrower type.';
      }
    }
  };

  const handleConfirmationResponse = async () => {
    if (!borrowerType) {
      return;
    }

    try {
      const response = await (
        borrowerType.statusLUId === STATUSLUTYPE.DELETED
          ? unDeleteBorrowerType(borrowerType.id)
          : deleteBorrowerType(borrowerType.id)
      );

      if (response.data.success) {
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000);
        handleDialogClose();
        setTimeout(updatePageData, 500);
      } else {
        console.error('Failed to delete/un-delete borrower type:', response.data.message);
        alert(`Failed to ${borrowerType.statusLUId === STATUSLUTYPE.DELETED ? "recover" : "delete"} borrower type.`);

      }
    } catch (error) {
      console.error('Error deleting/un-deleting borrower type:', error);
    }
  };

  const handleEditBorrowerType = (borrowerType) => {
    setBorrowerType(borrowerType);
    setShouldOpenEditorDialog(true);
  };

  useEffect(() => {
    updatePageData();
  }, [updatePageData]);

  return {
    page,
    borrowerType,
    setBorrowerType,
    borrowerTypeList,
    rowsPerPage,
    setRowsPerPage,
    handleSaveBorrowerType,
    handleEditBorrowerType,
    handleDeleteUnDeleteBorrowerType,
    handleChangePage,
    handleDialogClose,
    shouldOpenEditorDialog,
    setShouldOpenEditorDialog,
    handleConfirmationResponse,
    shouldOpenConfirmationDialog,
    updatePageData

  };
}
